import { META_EXPRESSION_SCOPE } from "fieldpro-tools";
import _ from "lodash";

import { TExpressionType } from "model/entities/Expression";
import { CUSTOM_FIELD_TYPE } from "model/entities/Workflow";

import { ICustomField } from "./getSchemaForMetaExpression";

const OPERATION_FIELD_TYPES = [
  CUSTOM_FIELD_TYPE.INTEGER,
  CUSTOM_FIELD_TYPE.DECIMAL,
  CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST,
  CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER,
  CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_DECIMAL,
  CUSTOM_FIELD_TYPE.MATRIX_ON_LIST,
  CUSTOM_FIELD_TYPE.COMPUTE,
  CUSTOM_FIELD_TYPE.RATING,
  CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
  CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
];

const CONDITION_FIELD_TYPES = [
  ...OPERATION_FIELD_TYPES,
  CUSTOM_FIELD_TYPE.TEXT,
  CUSTOM_FIELD_TYPE.PLAIN_TEXT,
  CUSTOM_FIELD_TYPE.BOOLEAN,
  CUSTOM_FIELD_TYPE.PHONE_NUMBER,
  CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_TEXT,
  CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
  CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
  CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST,
];

interface IGetCustomFieldOptionsArgs {
  scope?: META_EXPRESSION_SCOPE;
  expressionType?: TExpressionType;
  fieldType?: CUSTOM_FIELD_TYPE;
  includeMatrix?: boolean;
  includePictureType?: boolean;
}

export const getCustomFieldOptions = (
  fieldSchemas: ICustomField[],
  {
    scope,
    expressionType,
    fieldType,
    includeMatrix = true,
    includePictureType = false,
  }: IGetCustomFieldOptionsArgs = {},
) => {
  return fieldSchemas
    .filter((schema) => {
      if (includePictureType && schema.type === CUSTOM_FIELD_TYPE.PICTURE) {
        return true;
      }
      if (expressionType === "OPERATION") {
        return _.includes(OPERATION_FIELD_TYPES, schema.type);
      }
      if (expressionType === "CONDITION") {
        return _.includes(CONDITION_FIELD_TYPES, schema.type);
      }
      return true;
    })
    .filter((schema) => {
      // if we are filtering schema items by field type check the rule on including matrix
      if (fieldType && schema.type === CUSTOM_FIELD_TYPE.MATRIX_ON_LIST) {
        return includeMatrix;
      }
      return (
        !(schema.tag === "_name" && scope === META_EXPRESSION_SCOPE.CUSTOMER) &&
        (!fieldType || schema.type === fieldType)
      );
    })
    .map((schema) => ({
      key: schema.tag,
      label: schema.tag,
    }));
};
